import { useRouter } from '@tanstack/react-router';
import LanguageSelector from '@uturn/portal/components/language-selector';
import { Button, Logo } from '@uturn/ui-kit';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import authPhoto from '../../../assets/truck-on-road.webp';
import { PasswordResetForm } from '../components/password-reset-form';

export function AuthResetPassword() {
	const router = useRouter();
	const { t } = useTranslation();

	return (
		<>
			<Helmet
				title={t(
					'pages.auth.password_reset.title',
					'Reset password',
				).toString()}
			/>
			<div className="container relative min-h-screen flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
				<div className="absolute bottom-12 right-12 sm:right-4 sm:top-4 md:right-8 md:top-8">
					<LanguageSelector />
				</div>
				<div className="hidden h-screen overflow-hidden lg:block">
					<img
						src={authPhoto as string}
						alt=""
						className="size-full object-cover saturate-150"
					/>
				</div>
				<div className="w-full lg:p-8">
					<div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
						<div className="flex flex-col space-y-2 text-center">
							<Logo className="mb-8 h-8 w-auto" />
							<h1 className="text-2xl font-semibold tracking-tight">
								{t('pages.auth.password_reset.title', 'Reset your password')}
							</h1>
							<p className="text-sm text-muted-foreground">
								{t(
									'pages.auth.password_reset.description',
									`Enter your new password and we'll get you on your way.`,
								)}
							</p>
						</div>
						<PasswordResetForm />
						<div className="text-center text-sm text-muted-foreground">
							<Button
								variant="link"
								onClick={() => router.navigate({ to: '/sign-in' })}
							>
								{t('pages.auth.password_reset.actions.back', 'Back to login')}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
